import { aboutData } from '@/mocks/home';

export default function AboutSection() {
  return (
    <section id="about" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="max-w-[800px] mx-auto text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-6">
            平台简介
          </h2>
          <div className="w-16 h-1 bg-primary-500 mx-auto mb-8 rounded-full"></div>
          <p className="text-sm md:text-base text-foreground-600 leading-relaxed md:leading-loose">
            {aboutData.content}
          </p>
          <div className="flex flex-wrap items-center justify-center gap-8 mt-10">
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-primary-500">4+</div>
              <div className="text-xs text-foreground-500 mt-1">聚合平台</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-accent-500">1000万+</div>
              <div className="text-xs text-foreground-500 mt-1">月活用户</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-heading font-bold text-secondary-500">全天候</div>
              <div className="text-xs text-foreground-500 mt-1">内容更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}